<div class="body-map-viewer">
  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <div>
      <div class="fw-bold text-gray-800">{{ "bodyMap.title" | translate }}</div>
      <div class="text-muted fs-7" *ngIf="hasSelection">
        {{ "bodyMap.lesionLocation" | translate }}:
        {{ ("bodyMapRegion." + displayRegionId) | translate }}
      </div>
      <div class="text-muted fs-7" *ngIf="!hasSelection">
        {{ "bodyMap.empty" | translate }}
      </div>
    </div>
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="view === 'FRONT'"
        [class.btn-light]="view !== 'FRONT'"
        (click)="setView('FRONT')"
      >
        {{ "bodyMap.front" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="view === 'BACK'"
        [class.btn-light]="view !== 'BACK'"
        (click)="setView('BACK')"
      >
        {{ "bodyMap.back" | translate }}
      </button>
    </div>
  </div>

  <div class="body-map-stage" *ngIf="loaded">
    <div
      *ngIf="hasPreciseMarker && !use3dFailed"
      class="body-map-3d-wrap"
      [class.body-map-3d-wrap--loading]="!modelReady"
    >
      <div class="body-map-3d-host" #canvasHost></div>
      <div class="body-map-3d-loading" *ngIf="!modelReady">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
    </div>

    <div class="body-map-svg-wrap" *ngIf="!hasPreciseMarker || use3dFailed">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375.42 832.97" class="body-map-svg">
        <path
          *ngFor="let region of visibleRegions"
          [attr.d]="region.pathD"
          [attr.fill]="region.id === displayRegionId ? '#16265C' : '#DDE3F1'"
          [attr.stroke]="region.id === displayRegionId ? '#0D1838' : '#9AA8C8'"
          stroke-width="0.8"
          class="body-map-svg-path"
          (click)="onSvgRegionClick(region.id)"
        >
          <title>{{ ("bodyMapRegion." + region.id) | translate }}</title>
        </path>
      </svg>
    </div>
  </div>
</div>
